<template>
  <div class="live-show">
    <div class="live_video_block">
      <header>
        <span class="back" @click="closeVideo()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="16"
            viewBox="0 0 18 16"
          >
            <defs>
              <path
                id="a"
                d="M7.993 14.119c.395.432.4 1.127.007 1.558a.936.936 0 0 1-1.418-.004L.297 8.779a1.173 1.173 0 0 1 0-1.56L6.582.326A.94.94 0 0 1 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
              />
            </defs>
            <use fill="#FFF" fill-rule="evenodd" xlink:href="#a" />
          </svg>
        </span>
        <span class="head-profile" v-if="details && details.itemMediaDTOList">
          <img :src="details.itemMediaDTOList[0].small" alt />
        </span>
        <span class="title">
          <span class="name">{{details.productName}}</span>
          <span class="timing">
            <!-- <Timer
                :timing="getLiveTime(details.liveEndTimeMilis)"
                :GroupID="details.liveEndTimeMilis"
            />-->
          </span>
        </span>
        <span class="view" v-if="details && details.itemVideoDTOList && details.itemVideoDTOList">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13">
            <g fill="#FFF" fill-rule="evenodd">
              <path
                d="M1.802 6.795c.402.623.878 1.247 1.421 1.826C4.743 10.243 6.478 11.2 8.4 11.2c1.922 0 3.657-.957 5.177-2.579A12.96 12.96 0 0 0 15.302 6.3a12.96 12.96 0 0 0-1.725-2.321C12.057 2.357 10.322 1.4 8.4 1.4c-1.922 0-3.657.957-5.177 2.579A12.959 12.959 0 0 0 1.498 6.3c.089.152.19.318.304.495zM.074 5.987c.098-.197.283-.525.552-.942.445-.69.97-1.378 1.576-2.024C3.962 1.143 6.034 0 8.4 0c2.366 0 4.437 1.143 6.198 3.021.605.646 1.13 1.335 1.576 2.024.269.417.454.745.552.942a.7.7 0 0 1 0 .626c-.098.197-.283.525-.552.942-.445.69-.97 1.378-1.576 2.024-1.76 1.878-3.832 3.021-6.198 3.021-2.366 0-4.437-1.143-6.198-3.021A14.345 14.345 0 0 1 .626 7.555C.357 7.138.172 6.81.074 6.613a.7.7 0 0 1 0-.626z"
              />
              <path
                d="M8.4 9.1a2.8 2.8 0 1 1 0-5.6 2.8 2.8 0 0 1 0 5.6zm0-1.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8z"
              />
            </g>
          </svg>
          {{totalLivePeople}}
        </span>
      </header>
      <div class="post_video">
        <video
          id="itemVideo"
          poster="../../assets/images/mall91_logo.jpg"
          :src="videoSrc"
          autoplay
          controls
        ></video>
        <div class="video_share_btn" @click="shareFunc(details.shareMessageUrl,details.itemMediaDTOList[0].original, details.saleReferenceID)">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 16">
            <path
              fill="none"
              fill-rule="nonzero"
              stroke="#727272"
              stroke-width=".64"
              d="M17 7.495L10.35 0v4.472H8.938C4.553 4.472 1 8.124 1 12.63V15l.628-.707c2.135-2.405 5.156-3.775 8.323-3.775h.4v4.472L17 7.495z"
            />
          </svg>
          <span>{{$t('share')}}</span>
        </div>
        <router-link
          tag="div"
          class="comment_count"
          :to="{path: '/product-comment/'+ details.saleReferenceID }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <path
              fill="#FFF"
              fill-rule="evenodd"
              d="M3.205 10.205A.7.7 0 0 1 3.7 10h8.4a.7.7 0 0 0 .7-.7v-7a.7.7 0 0 0-.7-.7H2.3a.7.7 0 0 0-.7.7v9.51l1.605-1.605zM3.99 11.4l-2.595 2.595A.7.7 0 0 1 .2 13.5V2.3C.2 1.14 1.14.2 2.3.2h9.8c1.16 0 2.1.94 2.1 2.1v7a2.1 2.1 0 0 1-2.1 2.1H3.99z"
            />
          </svg>
          <span>{{details.commentCount}}</span>
        </router-link>
      </div>
      <ul class="product-show align-item">
        <li @click="goToProductDetail(details.saleReferenceID)">
          <span class="product-img">
            <img
              :src="productImg.original"
              v-for="(productImg,index) in details.itemMediaDTOList"
              :key="index"
            />
          </span>
          <div class="product-content">
            <span class="p-name">{{details.productName}}</span>
            <span class="p-price">
              <span>₹ {{details.finalPaidAmount}}</span>
              <strike>₹{{details.mrp}}</strike>
            </span>
            <span class="product-btn">{{$t('buyNow')}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import "../../assets/css/tv-shopping.scss";
import Timer from "../../components/Common/TimeCount";
export default {
  name: "RecordedShow",
  components: {
    Timer
  },
  data() {
    return {
      details: {},
      videoSrc: "",
      productImage: "",
      shareMessageUrl: ""
    };
  },
  methods: {
    getOldVideoLink() {
      this.loading = true;
      var obj = {
        saleReferenceID: this.$route.params.saleReferenceID,
        referralUserId: this.$route.query.referralUserId
      };
      this.$store
        .dispatch({
          type: "getProductDetail",
          payload: obj
        })
        .then(data => {          
          this.details = data.data;
          this.totalLivePeople = parseInt(
            Math.random() * (100000 - 5000) + 5000
          );
          if (
            this.details &&
            this.details.itemVideoDTOList &&
            this.details.itemVideoDTOList[0] &&
            this.details.itemVideoDTOList[0].original
          ) {
            this.videoSrc = this.details.itemVideoDTOList[0].original;
            this.productImage = this.details.itemMediaDTOList[0].original;
            this.shareMessageUrl = this.details.shareMessageUrl;
          }
          this.$store.commit("saveProductDetails", {
            details: data.data,
            saleRefID: this.$route.params.saleReferenceID
          });
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      clevertap.event.push("Share_Video_Link");
      this.loading = true;
      this.$store
        .dispatch({ type: "getShareDetailsByItem", payload: saleReferenceID +'?type=video' })
        .then(data => {
          this.shareLinkData = data.data;
          this.loading = false;
          shareMessage = data.data.shareMessage;
          const obj = {
            message: shareMessage,
            imageUrl: shareImage
          };
          try {
            JSBridgePlugin.share(JSON.stringify(obj));
          } catch (err) {
            console.log(err);
            window.open("whatsapp://send?text=" + shareMessage);
          }
        })
        .catch(err => {
          this.loading = false;
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },
    goToProductDetail(productSrId) {
      clevertap.event.push("RECORDED_VID_BUYNOW");
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push(
        "/detail/" + productSrId + "?source=MALL91_RECORDED_VIDEO"
      );
    },
    closeVideo() {
      const vid = document.getElementById("itemVideo");
      vid.pause();
      this.$router.go(-1);
    }
  },
  mounted() {
    this.getOldVideoLink();
  }
};
</script>
